import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Table = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 45 33.75 L 33.75 33.75 L 33.75 45 L 41.875 45 C 43.601562 45 45 43.601562 45 41.875 Z M 33.75 30 L 45 30 L 45 18.75 L 33.75 18.75 Z M 3.75 30 L 30 30 L 30 18.75 L 3.75 18.75 Z M 3.75 41.875 C 3.75 43.601562 5.148438 45 6.875 45 L 30 45 L 30 33.75 L 3.75 33.75 Z M 45 6.875 C 45 5.148438 43.601562 3.75 41.875 3.75 L 33.75 3.75 L 33.75 15 L 45 15 Z M 3.75 15 L 30 15 L 30 3.75 L 6.875 3.75 C 5.148438 3.75 3.75 5.148438 3.75 6.875 Z M 48.75 41.875 C 48.75 45.671875 45.671875 48.75 41.875 48.75 L 6.875 48.75 C 3.078125 48.75 0 45.671875 0 41.875 L 0 6.875 C 0 3.078125 3.078125 0 6.875 0 L 41.875 0 C 45.671875 0 48.75 3.078125 48.75 6.875 Z M 48.75 41.875"
        fill={color}
      />
    </svg>
  )
}
